import React from 'react';
import * as R from "ramda";
import { LoadingState } from '../../../../_common/loadingState';
import { PaymentTableFilter } from './filter';
import PaymentTableNav from './nav';
import { PaymentTableRow } from './row';
import Emptylustration from '../../../../assets/images/svg/057-contract-1.svg';

export const PaymentTable = ({ invoices, filteredInvoices, routerQuery, pageSearch, setPageSearch, date, setDate, setSelectedInvoice, partner, etablissement }) => {
    return (
        <div className="container-fluid h-100 flex-column">
            <PaymentTableFilter routerQuery={routerQuery} pageSearch={pageSearch} setPageSearch={setPageSearch} date={date} setDate={setDate} />

            {R.isEmpty(invoices.items) ?
                <section className="block fs-3 text-center m-auto py-4">
                    <img className="img-fluid img-contain container-paper mx-auto  mt-auto mb-4" src={Emptylustration} alt="Assist@" />
                    <div className="block text-center container-thin mx-auto mb-auto">
                        <h1 className="font-weight-bolder ls-n2 lh-1">Il n'y a pas de factures.</h1>
                    </div>
                </section>
                :
                invoices.isLoading ?
                    <section className="flex-column h-100"><LoadingState /></section>
                    :
                    <section className="block">
                        <PaymentTableNav routerQuery={routerQuery} invoices={invoices} />
                        {
                            filteredInvoices.map((invoice) => {
                                return <PaymentTableRow key={invoice.id} invoice={invoice} setSelectedInvoice={setSelectedInvoice} partner={partner} etablissement={etablissement} />;
                            })
                        }
                    </section>}
        </div>
    );
};

